function createBasicAuthConfig(username, password) {
  let authBasic = ''
  if (password) {
    authBasic = window.btoa(username + ":" + password)
  } else {
    authBasic = window.btoa(username + ":")
  }
  const config = {
    'headers': {
      'Authorization': 'Basic ' + authBasic,
    }
  }

  return config
}

function preprocessErrorResponse(err) {
  if (err.response != null) {
    return err.response.data
  } else {
    return { status: 'failure' }
  }
}

export { createBasicAuthConfig, preprocessErrorResponse }